export default __webpack_public_path__ + "static/media/05-1v2.429783ac.png";